import { makeStyles } from '@mui/styles';

export const useEditableClockInputStyles = makeStyles(theme => ({
  root: {
    '& input': {
      fontSize: theme.typography.h3.fontSize,
      backgroundColor: 'transparent',
      color: 'white',
      padding: 0,
      margin: 0,
      borderRadius: 6,
      width: 60,
      outline: 0,
      textAlign: 'center',
    },

    '& input:focus': {
      color: theme.palette.secondary.light,
      transition: 'color ease-in .10s',
    },
  },
}));
